import React, { memo, useContext } from "react";

import GridContainer from "../../../componentsv2/GridContainer";
import GridItem from "../../../componentsv2/GridItem";
import Paper from "../../../componentsv2/Paper";
import DataPickerAtualizado from "../../../components/DataPickerAtualizado";
import TabelaNotasFiscaisExpansivel from "../Componentes/TabelaNotasFiscaisExpansivel";
import { IntervaloDataContext } from "../Context/IntevervaloDataContext";
import { NotasFiscaisContext } from "../Context/NotasFiscaisContext";

function NotasFiscais() {
  const { dataInicio, setDataInicio, dataFim, setDataFim } =
    useContext(IntervaloDataContext);
  const {
    notasFiscaisTabela,
    loadingNotasFiscais,
    buscarCompetenciasNota,
    salvarCompetenciasNota,
  } = useContext(NotasFiscaisContext);

  return (
    <Paper style={{ backgroundColor: "white", width: "100%" }}>
      <GridContainer
        spacing={1}
        justifyContent="space-evenly"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <GridItem xs={8}>
          <GridContainer
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{
              border: "0.1rem solid #CDCDCD",
              borderRadius: "0.2rem",
              padding: "1rem",
            }}
          >
            <GridItem xs={3}>
              <DataPickerAtualizado
                data={dataInicio}
                labelName="Data inicial"
                setData={setDataInicio}
              />
            </GridItem>
            <GridItem xs={3}>
              <DataPickerAtualizado
                data={dataFim}
                labelName="Data final"
                setData={setDataFim}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <TabelaNotasFiscaisExpansivel
        rows={notasFiscaisTabela}
        loading={loadingNotasFiscais}
        buscarCompetenciasNota={buscarCompetenciasNota}
        salvarCompetenciasNota={salvarCompetenciasNota}
      />
    </Paper>
  );
}

export default memo(NotasFiscais);
